export const sortAlphabeticallyObjectByKey = (options: [], key: string) => {
  return options.sort((a, b) => {
    if (a[key] && b[key]) {
      if (a[key] < b[key]) {
        return -1;
      }
      if (a[key] > b[key]) {
        return 1;
      }
    }
    return 0;
  });
};

export const replaceStringDotsWithUnderscores = (str: string) =>
  str.replace(/\./g, '_');

export const replaceStringUnderscoresWithDots = (str: string) =>
  str.replace(/_/g, '.');

export const replaceDotsWithUnderscores = (strings: string[]): string[] => {
  return strings.map((str) => replaceStringDotsWithUnderscores(str));
};

export const replaceUnderscoresWithDots = (strings: string[]): string[] => {
  return strings.map((str) => replaceStringUnderscoresWithDots(str));
};
